import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  .BaSe--modal-container {
    padding: 0;
    ::before {
      opacity: 1;
    }

    .BaSe--modal-dialog {
      width: 100%;
      margin-bottom: 90px;
      background-color: unset;
      border: unset;


    }

  .sc-dJjYzT {
      position: relative;
      padding: 16px 0 60%;
      width: auto;
      margin-left: auto;
      margin-right: auto;

      video {
        position: absolute;
        top: 0;
        left: 0;
        margin-top: 30px;

        @media (min-width: 381px) {
          margin-top: 17px;
        }
      }

      img {
        height: 400px;
        margin: 0 auto;

        @media (min-width: 381px) {
          max-height: 500px;
          height: 100%;
        }
      }
    }
  }

  audio {
    ::-webkit-media-controls-enclosure {
    border-radius: 5px;
    background-color: #fff;
    }
  }
`;
